/** Mirrors backend `demo_agency_setup.defaults` (EMR-471). */
export const DEFAULT_DEMO_FF_TEMPLATE_AGENCY = 'NewDay';

export const DEFAULT_DEMO_TEAM_MEMBER_EMAILS: readonly string[] = [
  'yunus@rogerhealthcare.com',
  'matthew@rogerhealthcare.com',
  'sarah@rogerhealthcare.com',
];

/** Mirror backend `demo_clinic_fallbacks`: what a run writes when a profile field is empty. */
export const DEMO_FALLBACK_NPI = '1234567893';
export const DEMO_FALLBACK_EIN = '123456789';
export const DEMO_FALLBACK_PHONE = '4155550100';
export const DEMO_FALLBACK_ADDRESS = '100 Market St';
export const DEMO_FALLBACK_CITY = 'San Francisco';
export const DEMO_FALLBACK_STATE = 'CA';
export const DEMO_FALLBACK_ZIP = '94105';
// CMS "no branches": a blank OASIS M0016 is rejected, so empty Branch ID gets N.
export const DEMO_FALLBACK_CMS_BRANCH_ID = 'N';
export const DEMO_FALLBACK_CCN = '123456';
export const DEMO_FALLBACK_CMS_QIES_AGENCY_ID = 'DEMO000HHA';
export const DEMO_FALLBACK_BILLING_CONTACT_FIRST_NAME = 'John';
export const DEMO_FALLBACK_BILLING_CONTACT_LAST_NAME = 'Biller';
export const DEMO_FALLBACK_BILLING_CONTACT_PHONE = DEMO_FALLBACK_PHONE;
